import { useId } from 'react'
import { ButtonLink } from '@/components/ui/Button'

// Copy per Website Review (May 2026).
const PARTNER_GAINS = [
  {
    title: 'Access',
    body: 'Peer network of cross-sector leaders driving longevity innovation.',
  },
  {
    title: 'Intelligence',
    body: 'Research and insights that will drive business impact and outcomes.',
  },
  {
    title: 'Impact',
    body: 'Industry leadership in co-creating the frameworks, products, and policies that will define the longevity economy.',
  },
]

/**
 * For Organizations — Website Review V2: lighter, inviting background (was a
 * dark band), the nine ecosystem boxes removed, and the value proposition led
 * by "Become a LifeSpan Founding Partner" + What Partners Gain.
 */
export function Ecosystem() {
  const headingId = useId()

  return (
    <section
      id="ecosystem"
      aria-labelledby={headingId}
      className="bg-gia-blue-light-2 py-section-y text-ink-deep"
    >
      <div className="mx-auto max-w-[88rem] px-6 sm:px-10">
        <header className="grid grid-cols-1 gap-y-6 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <span className="eyebrow text-ink-deep">For organizations</span>
            <h2
              id={headingId}
              className="mt-4 font-display text-display-2 font-extrabold text-ink-deep"
            >
              Become a LifeSpan Founding Partner.
            </h2>
          </div>
          <div className="space-y-4 lg:col-span-5 lg:col-start-8 lg:pt-3">
            <p className="text-lg leading-relaxed text-ink-slate lg:text-xl">
              Longer life expectancy is one of the greatest opportunities of
              our time. To realize its potential, we need new approaches that
              support people across the life span&mdash;from 0 to 100+ years.
            </p>
            <p className="text-lg leading-relaxed text-ink-slate lg:text-xl">
              Partner with GIA Longevity to build the strategies, products,
              and workplaces that will shape a thriving, multi-generational
              future.
            </p>
          </div>
        </header>

        {/* What Partners Gain */}
        <div className="mt-16 border-t border-ink-deep/15 pt-12">
          <h3 className="font-display text-display-3 font-extrabold text-ink-deep">
            What Partners Gain
          </h3>
          <ul
            role="list"
            className="mt-10 grid grid-cols-1 gap-y-10 md:grid-cols-3 md:gap-x-12"
          >
            {PARTNER_GAINS.map((gain) => (
              <li key={gain.title} className="border-t-2 border-brand pt-5">
                <h4 className="font-display text-xl font-extrabold text-ink-deep">
                  {gain.title}
                </h4>
                <p className="mt-3 max-w-xs text-base leading-relaxed text-ink-slate">
                  {gain.body}
                </p>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-14">
          <ButtonLink href="#contact" variant="primary" size="lg">
            Partner with us
          </ButtonLink>
        </div>
      </div>
    </section>
  )
}
